import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import clsx from "clsx";
import { tooltipContent } from "./Tooltip.css";

/**
 * Names or describes its trigger on hover and on keyboard focus. The content
 * takes no pointer: anything a user has to act on belongs in a `Popover`.
 */
export function Tooltip(
  props: React.ComponentProps<typeof TooltipPrimitive.Root>
) {
  return (
    // Its own provider, so a consumer needs no app-root wiring; a shared one
    // can replace it later. Hoverable content is off: the content takes no
    // pointer, so the transit tracking would only delay the close.
    <TooltipPrimitive.Provider delayDuration={150} disableHoverableContent>
      <TooltipPrimitive.Root {...props} />
    </TooltipPrimitive.Provider>
  );
}

export function TooltipTrigger(
  props: React.ComponentProps<typeof TooltipPrimitive.Trigger>
) {
  return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />;
}

export function TooltipContent({
  sideOffset = 6,
  collisionPadding = 8,
  className,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Content>) {
  return (
    // Portalled: a trigger inside a clipping panel or dialog would otherwise
    // have its tooltip cut off at the panel's edge.
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        collisionPadding={collisionPadding}
        className={clsx(tooltipContent, className)}
        {...props}
      />
    </TooltipPrimitive.Portal>
  );
}
